'use client';

import { ACHAccountNumber } from '@sola/ark-core/molecules/ach-fields/ach-account-number.js';
import { ACHName } from '@sola/ark-core/molecules/ach-fields/ach-name.js';
import { ACHRoutingNumber } from '@sola/ark-core/molecules/ach-fields/ach-routing-number.js';
import { InputField } from '@sola/ark-core/molecules/input-field/input-field.js';

export const PaymentACHFields = () => {
  return (
    <>
      <ACHAccountNumber
        name="accountNumber"
        label="Account number"
        required
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {}}
      />

      <ACHRoutingNumber
        name="routingNumber"
        label="Routing number"
        required
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {}}
      />

      <ACHName
        name="accountName"
        label="Name on account"
        required
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {}}
      />

      <InputField
        name="nickname"
        label="Nickname for this account"
        hint="(optional)"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {}}
      />
    </>
  );
};
